import { useState, useEffect, useRef } from 'react'
import classnames from 'classnames/bind'

// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

interface IInput extends React.InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string
  hasError?: boolean
  isFieldFocus?: boolean
  label?: string
}

const InputComponent = (props: IInput) => {
  const { className, autoFocus, type, hasError = false, isFieldFocus, wrapperClassName, placeholder = '', label, ...restProps } = props

  const isPasswordType = type === 'password'

  const [currentInputType, setInputType] = useState(type)

  const isPasswordHidden = currentInputType === 'password'

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (autoFocus || isFieldFocus) inputRef.current?.focus()
  }, [autoFocus, isFieldFocus])

  const handleEyeClick = () => {
    if (isPasswordType) {
      if (isPasswordHidden) {
        setInputType('text')
      } else {
        setInputType('password')
      }
    }
  }

  return (
    <div className={cx('input-wrapper', wrapperClassName)}>
      <input
        ref={inputRef}
        className={cx('input-wrapper-input', className)}
        type={currentInputType}
        data-is-password={isPasswordType}
        data-has-error={hasError}
        data-has-label={Boolean(label)}
        placeholder={placeholder}
        {...restProps}
      />
      {label && <label className={cx('input-wrapper-label')}>{label}</label>}
      {isPasswordType && (
        <div className={cx('input-wrapper-icon')} onClick={handleEyeClick}>
          {isPasswordHidden && <Icon.EyeClose />}
          {!isPasswordHidden && <Icon.EyeOpen />}
        </div>
      )}
    </div>
  )
}

export default InputComponent
